const initialState = {};

export default function sourceReducer(state = initialState, action) {
  switch (action.type) {
    case "source/update":
      {
        let newState = { ...state };

        newState[action.payload.id][action.payload.property] =
          action.payload.value;

        return newState;
      }

      break;

    case "source/add":
      let newState = { ...state };

      if (action.payload.id) {
        if (!newState[action.payload.id]) {
          newState[action.payload.id] = {};
        }
      }
      Object.keys(action.payload)?.forEach((el) => {
        if (Object.keys(newState).indexOf(el) < 0) {
          newState[el] = { ...action.payload[el] };
        }
      });

      return { ...newState };
      break;

    default:
      return state;
  }
}
